import {GridColumn, GridColumnGroupDef} from "@data/interefaces/data.interfaces";
import {ColumnFilterType} from "@data/enums/data.enums";
import {
  CircleCheckColumnComponent
} from "@pages/segments/grid/columns/circle-check-column/circle-check-column.component";
import {LongDataColumnComponent} from "@pages/segments/grid/columns/long-data-column/long-data-column.component";
import {Util} from "@data/util/util";
import {StatusColumnComponent} from "@pages/segments/grid/columns/status-column/status-column.component";
import {ActionColumnComponent} from "@pages/segments/grid/columns/action-column/action-column.component";
import {UserListComponent} from "@pages/system/client-portal/user-list/user-list.component";
import {ResetFilterComponent} from "@pages/segments/grid/filters/reset-filter/reset-filter.component";

export const assignClickAction: string = 'assign_button_link_click';
export const releaseClickAction: string = 'release_button_link_click';
export const permanentClickAction: string = 'permanent_button_link_click';
export const temporaryClickAction: string = 'temporary_button_link_click';

export let pageContext: {
  [key: string]: boolean | string | undefined
  l_f: string | undefined;
  e_f: string | undefined;
  fn_f: string | undefined;
  ln_f: string | undefined;
  at_f: string | undefined;
  gu_f: string | undefined;
  tu_f: string | undefined;
  os_f: string | undefined;
  o_f: string | undefined;
  ocd_f: string | undefined;
  oag_f: string | undefined;
  ocg_f: string | undefined;
  ts_f: string | undefined;
  ta_f: string | undefined;
  tsite_f: string | undefined;
  tl_f: string | undefined;
  tlp_f: string | undefined;
  tle_f: string | undefined;
  tad_f: string | undefined;
  tdd_f: string | undefined;
  ldd_f: string | undefined;
  ps_f: string | undefined;
  pn_f: string | undefined;
} = {
  l_f: undefined,
  e_f: undefined,
  fn_f: undefined,
  ln_f: undefined,
  at_f: undefined,
  gu_f: undefined,
  tu_f: undefined,
  os_f: undefined,
  o_f: undefined,
  ocd_f: undefined,
  oag_f: undefined,
  ocg_f: undefined,
  ts_f: undefined,
  ta_f: undefined,
  tsite_f: undefined,
  tl_f: undefined,
  tlp_f: undefined,
  tle_f: undefined,
  tad_f: undefined,
  tdd_f: undefined,
  ldd_f: undefined,
  ps_f: undefined,
  pn_f: undefined,
}

export let tableColumns: (GridColumn | GridColumnGroupDef)[] = [
  {
    field: 'login',
    headerName: 'Login',
    filterId: 'l_f',
    pinned: "left",
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    minWidth: 200,
  },
  {
    valueGetter: (params) => params.data ? `${params.data.email} (${params.data.firstName} ${params.data.lastName})` : '',
    headerName: 'Email',
    filterId: 'e_f',
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },

    minWidth: 300,
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    filterId: 'fn_f',
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },

    hide: true,
    minWidth: 80,
  },
  {
    field: 'middleName',
    headerName: 'Middle Name',
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },

    hide: true,
    minWidth: 80,
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    filterId: 'ln_f',
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },

    hide: true,
    minWidth: 80,
  },
  {
    field: 'accountType',
    headerName: 'Account Type',
    filterId: 'at_f',
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    enableRowGroup: true,
  },
  {
    field: 'groupUser',
    headerName: 'Group User',
    filterId: 'gu_f',
    filter: ColumnFilterType.DROPDOWN,
    enableRowGroup: true,
    filterParams: {
      defaultToNothingSelected: true,
      cellRenderer: CircleCheckColumnComponent,
      cellRendererParams: function (params: any) {
        return {
          iconSize: 'fa-lg'
        };
      },
      buttons: ['reset']
    },
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'testUser',
    headerName: 'Test User',
    filterId: 'tu_f',
    filter: ColumnFilterType.DROPDOWN,
    enableRowGroup: true,
    filterParams: {
      defaultToNothingSelected: true,
      cellRenderer: CircleCheckColumnComponent,
      cellRendererParams: function (params: any) {
        return {
          iconSize: 'fa-lg'
        };
      },
      buttons: ['reset']
    },
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'oktaSource',
    headerName: 'OKTA source',
    filterId: 'os_f',
    hide: true,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    cellRenderer: LongDataColumnComponent,
    cellRendererParams: function (params: any) {
      if (params.node.group) {
        return;
      }
      return {
        text: params.data.oktaSource,
        type: 'link',
      };
    },
  },
  {
    field: 'oktaState',
    headerName: 'Okta State',
    filterId: 'o_f',
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    enableRowGroup: true,
  },
  {
    field: 'oktaCreatedTimestamp',
    headerName: 'Okta Creation Date',
    filterId: 'ocd_f',
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDate(params?.value);
    },
  },
  {
    field: 'oktaAgiGroups',
    headerName: 'Okta AGI Groups',
    filterId: 'oag_f',
    hide: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      values: (params: any) => getUniqueGroupNames(params, "oktaAgiGroups"),
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    valueGetter: params => params.data?.oktaAgiGroups?.join(", ") || ""
  },
  {
    field: 'oktaClientGroups',
    headerName: 'Okta Client Groups',
    filterId: 'ocg_f',
    hide: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      values: (params: any) => getUniqueGroupNames(params, "oktaClientGroups"),
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    valueGetter: params => params.data?.oktaClientGroups?.join(", ") || ""
  },
  {
    field: 'tableauServer',
    headerName: 'Tableau Server',
    filterId: 'ts_f',
    hide: true,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    cellRenderer: LongDataColumnComponent,
    cellRendererParams: function (params: any) {
      if (params.node.group) {
        return;
      }
      return {
        text: params.data.tableauServer,
        type: 'link',
      };
    },
  },
  {
    field: 'hasTableauAccount',
    headerName: 'Has Tableau Account',
    filterId: 'ta_f',
    hide: true,
    filter: ColumnFilterType.DROPDOWN,
    enableRowGroup: true,
    filterParams: {
      defaultToNothingSelected: true,
      cellRenderer: CircleCheckColumnComponent,
      cellRendererParams: function (params: any) {
        return {
          iconSize: 'fa-lg'
        };
      },
      buttons: ['reset']
    },
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'tableauSite',
    headerName: 'Tableau Site',
    filterId: 'tsite_f',
    hide: true,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    cellRenderer: LongDataColumnComponent,
    cellRendererParams: function (params: any) {
      if (params.node.group) {
        return;
      }
      return {
        text: params.data.tableauSite,
        type: 'link',
      };
    },
  },
  {
    field: 'hasTableauLicense',
    headerName: 'Has Tableau License',
    filterId: 'tl_f',
    filter: ColumnFilterType.DROPDOWN,
    enableRowGroup: true,
    filterParams: {
      defaultToNothingSelected: true,
      cellRenderer: CircleCheckColumnComponent,
      cellRendererParams: function (params: any) {
        return {
          iconSize: 'fa-lg'
        };
      },
      buttons: ['reset']
    },
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'tableauLicenseIsPermanent',
    headerName: 'Is Tableau Permanent',
    filterId: 'tl_f',
    hide: true,
    filter: ColumnFilterType.DROPDOWN,
    enableRowGroup: true,
    filterParams: {
      defaultToNothingSelected: true,
      cellRenderer: CircleCheckColumnComponent,
      cellRendererParams: function (params: any) {
        return {
          iconSize: 'fa-lg'
        };
      },
      buttons: ['reset']
    },
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'tableauLicenseExpiryDatetime',
    headerName: 'Tableau License Expiry Date',
    filterId: 'tle_f',
    hide: true,
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDate(params?.value);
    },
  },
  {
    field: 'tableauActivationDatetime',
    headerName: 'Tableau License Activation Date',
    filterId: 'tad_f',
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDate(params?.value);
    },
  },
  {
    field: 'tableauDeactivationDatetime',
    headerName: 'Tableau License Deactivation Date',
    filterId: 'tdd_f',
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDate(params?.value);
    },
  },
  {
    field: 'lastDashboardViewDatetime',
    headerName: 'Last Dashboard View Date',
    filterId: 'ldd_f',
    hide: true,
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDate(params?.value);
    },
  },
  {
    field: 'processStatus',
    pinned: 'right',
    headerName: 'Process Status',
    filterId: 'ps_f',
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    cellRenderer: StatusColumnComponent
  },
  {
    field: 'processResult',
    headerName: 'Process Notes',
    pinned: 'right',
    cellRenderer: LongDataColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        text: params.value || '',
        type: 'text',
      };
    },
  },

  {
    field: 'processStatus',
    pinned: 'right',
    headerName: 'Processing',
    maxWidth: 120,
    filter: false,
    cellRenderer: (params: any) => {
      if (UserListComponent.isUserRequestInProcessing(params.data)) {
        return '<i class="fa fa-spinner fa-spin fa-lg" style="color: blue;"></i>';
      } else {
        return '';
      }
    },
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
  },
  {
    field: "actions",
    headerName: "Actions",
    pinned: "right",
    maxWidth: 140,
    filter: true,
    floatingFilter: true,
    floatingFilterComponent: ResetFilterComponent,
    suppressFloatingFilterButton: true,
    suppressHeaderFilterButton: true,
    downloadable: false,
    cellRenderer: ActionColumnComponent,
    cellRendererParams: function (params: any) {
      const actions = [];
      if (params.data && !UserListComponent.isUserRequestInProcessing(params.data)) {
        if (UserListComponent.couldAssignTableauLicense(params.data)) {
          actions.push({
            toolTip: "License",
            icon: "fa-id-card",
            name: "License",
            actionEvent: assignClickAction,
          });
        }
        if (UserListComponent.couldReleaseTableauLicense(params.data)) {
          actions.push({
            toolTip: "UnLicense",
            icon: "fa-ban",
            name: "UnLicense",
            actionEvent: releaseClickAction,
          });
        }
        if (UserListComponent.couldMakeLicensePermanent(params.data)) {
          actions.push({
            toolTip: "Make License Permanent",
            icon: "fa-user-cog",
            name: "MakeLicensePermanent",
            actionEvent: permanentClickAction,
          });
        }
        if (UserListComponent.couldMakeLicenseTemporary(params.data)) {
          actions.push({
            toolTip: "Make License Temporary",
            icon: "fa-calendar-alt",
            name: "MakeLicenseTemporary",
            actionEvent: temporaryClickAction,
          });
        }
      }
      return {actions};
    },
  }
];

function getUniqueGroupNames(params: any, fieldName: string): void {
  const uniqueGroups: Set<string> = new Set();

  // Extract unique group names from the specified field in the grid data
  params.api.forEachNode((node: any) => {
    const groups: string[] = node.data[fieldName];
    if (Array.isArray(groups)) {
      groups.forEach(group => uniqueGroups.add(group));
    }
  });

  // Return the unique group names as dropdown options
  params.success(Array.from(uniqueGroups));
}



